import { Role } from './roles';

enum Page {
  ROOT = 'ROOT',
  GENERAL = 'GENERAL',
  PROVIDERS = 'PROVIDERS',
  // PROVIDERSID = 'PROVIDERSID',
  OVERHEAD = 'OVERHEAD',
  FINALVERSION = 'FINALVERSION',
  AVAILABLEPERCENTAGE = 'AVAILABLEPERCENTAGE',
  PROJECTPRIORITY = 'PROJECTPRIORITY',
  RESOURCEDONORS = 'RESOURCEDONORS',
  SPECIFICALLOCATION = 'SPECIFICALLOCATION',
  ALLOCATIONPRIORITY = 'ALLOCATIONPRIORITY',
  POSITIONRESTRICTION = 'POSITIONRESTRICTION',
  UPLOADHISTORIC = 'UPLOADHISTORIC',
  PROFILE = 'PROFILE',
  CONSIDERCOLLABORATOR = 'CONSIDERCOLLABORATOR',
  EXTRACOLLABORATOR = 'EXTRACOLLABORATOR',
  ALLOCATIONCONSTRAINT = 'ALLOCATIONCONSTRAINT',
  DISREGARDEVENTS = 'DISREGARDEVENTS',
}

/**
 * Since every page is accessed only if the user owns certain roles,
 * we must define a set of Pages and the roles of every page
 */

export const PAGE_ROLES: Record<Page, Array<string>> = {
  ROOT: [Role.ADMIN, Role.PMO],
  GENERAL: [Role.ADMIN, Role.PMO],
  PROVIDERS: [Role.ADMIN, Role.PMO],
  OVERHEAD: [Role.ADMIN, Role.PMO],
  FINALVERSION: [Role.ADMIN, Role.PMO],
  AVAILABLEPERCENTAGE: [Role.ADMIN, Role.PMO],
  PROJECTPRIORITY: [Role.ADMIN, Role.PMO],
  RESOURCEDONORS: [Role.ADMIN, Role.PMO],
  SPECIFICALLOCATION: [Role.ADMIN, Role.PMO],
  ALLOCATIONPRIORITY: [Role.ADMIN, Role.PMO],
  POSITIONRESTRICTION: [Role.ADMIN, Role.PMO],
  UPLOADHISTORIC: [Role.ADMIN, Role.PMO],
  PROFILE: [Role.ADMIN],
  CONSIDERCOLLABORATOR: [Role.ADMIN, Role.PMO],
  EXTRACOLLABORATOR: [Role.ADMIN, Role.PMO],
  ALLOCATIONCONSTRAINT: [Role.ADMIN, Role.PMO],
  DISREGARDEVENTS: [Role.ADMIN, Role.PMO],
};

export const PAGE_PATHS: Record<Page, string> = {
  ROOT: '/',
  GENERAL: '/general',
  PROVIDERS: '/providers',
  OVERHEAD: '/overhead',
  FINALVERSION: '/final-version',
  AVAILABLEPERCENTAGE: '/available-percentage',
  PROJECTPRIORITY: '/project-priority',
  RESOURCEDONORS: '/resource-donors',
  SPECIFICALLOCATION: '/specific-allocation',
  ALLOCATIONPRIORITY: '/allocation-priority',
  POSITIONRESTRICTION: '/position-restriction',
  PROFILE: '/profile',
  CONSIDERCOLLABORATOR: '/consider-collaborator',
  UPLOADHISTORIC: '/historic',
  EXTRACOLLABORATOR: '/extra-collaborator',
  ALLOCATIONCONSTRAINT: '/allocation-constraint',
  DISREGARDEVENTS: '/disregard-events',
};

export default Page;
